function escapeHtml(value: string): string {
  return value
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#039;');
}

function renderPromoCard(signupUrl: string): string {
  return `
            <table width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background-color: #f0f4ff; border-radius: 12px; border: 1px solid #e0e7ff;">
              <tr>
                <td style="padding: 24px; text-align: center;">
                  <p style="margin: 0 0 12px 0; padding: 0; color: #1e3a8a; font-size: 15px; font-weight: 600; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;">
                    Want to create your own Smart Rooms?
                  </p>
                  <p style="margin: 0 0 16px 0; padding: 0; color: #4b5563; font-size: 14px; line-height: 1.5; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;">
                    Get started with Smart Rooms XP and build your own collaboration spaces.
                  </p>
                  <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="margin: 0 auto;">
                    <tr>
                      <td align="center" style="border-radius: 8px; background-color: #ffffff; border: 2px solid #1e3a8a;">
                        <a href="${escapeHtml(signupUrl)}" target="_blank" style="display: inline-block; padding: 12px 24px; color: #1e3a8a; text-decoration: none; font-weight: 600; font-size: 14px; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;">
                          Get Started →
                        </a>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>`;
}

/** Shared signup promo block for transactional emails (room invite, chat, content share). */
export function getEmailPromotionalSectionHtml(
  hidePromotionalSection?: boolean,
  utmMedium = 'email'
): string {
  if (hidePromotionalSection) return '';

  const signupUrl = `https://www.smartroomsxp.com?utm_source=email&utm_medium=${utmMedium}&utm_campaign=signup`;
  return `
        <tr>
          <td style="padding: 20px 0 0 0;">
            ${renderPromoCard(signupUrl)}
          </td>
        </tr>
  `;
}

/** Same signup card, for the plain Smart Share email (not the shared base template). */
export function getStandaloneEmailPromotionalHtml(
  signupUrl?: string,
  hidePromotionalSection?: boolean
): string {
  if (hidePromotionalSection || !signupUrl) return '';

  return `
          <div style="margin-top: 28px;">
            ${renderPromoCard(signupUrl)}
          </div>`;
}

export function getEmailPromotionalSectionText(
  hidePromotionalSection?: boolean,
  signupUrl = 'https://www.smartroomsxp.com'
): string {
  if (hidePromotionalSection) return '';

  return `
Want to create your own Smart Rooms?
Get started with Smart Rooms XP: ${signupUrl}
  `.trim();
}
